import { render, staticRenderFns } from "./NBest.vue?vue&type=template&id=4636a734"
import script from "./NBest.vue?vue&type=script&lang=js"
export * from "./NBest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports